'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, FlexProps, Text } from '@chakra-ui/react'
import { GetPriceResponse } from '@leid/api-orders'

import { Product } from 'appTypes/items'
import { getProductImageUrl } from 'utils/getProductImageUrl'
import { removeDecimals } from 'utils/removeDecimals'

import { ImageWrapper } from './styles'

type Props = {
  isDark?: boolean
  product?: Product
  category?: string
  pricePerDay?: number | undefined | null | string
  price?: number | undefined | null | string
  calculatedPrice?: GetPriceResponse
  amount?: number
} & FlexProps

export const ProductCardHorizontal: React.FC<Props> = ({
  isDark = false,
  product,
  category,
  pricePerDay,
  price,
  calculatedPrice,
  amount,
  ...flexProps
}) => {
  const { t } = useTranslation('common')

  if (!product) {
    return null
  }

  return (
    <Flex {...flexProps}>
      <ImageWrapper>
        <img loading="lazy" src={getProductImageUrl(product) || ''} alt="" />
      </ImageWrapper>

      <Box marginLeft="20px">
        <Text color={isDark ? 'green.a200' : 'green.a250'} fontSize="xs" fontWeight="700">
          {t(category || '')}
        </Text>
        <Text color={isDark ? 'black' : 'white'} fontSize="xs" fontWeight={600} lineHeight="12px" marginBottom="3px">
          {product.name}
        </Text>

        {calculatedPrice ? (
          <>
            <Text
              color={isDark ? 'black' : 'white'}
              fontSize="xs"
              fontWeight="400"
              lineHeight={1}
              className={product.oneTimeBuy ? 'gtm-complementary-price' : ''}
            >
              {removeDecimals(calculatedPrice.price * (amount && amount > 0 ? amount : 1))} {t('nok')}
            </Text>

            {calculatedPrice.rebateAmount !== undefined && (
              <>
                <Text fontSize="xs" textDecoration="line-through">
                  {'('}
                  {t('common:originalPrice')}{' '}
                  {removeDecimals(
                    (calculatedPrice.price + (calculatedPrice.rebateAmount ?? 0)) * (amount && amount > 0 ? amount : 1),
                  )}{' '}
                  {t('nok')}
                  {')'}
                </Text>
              </>
            )}
          </>
        ) : (
          <>
            {pricePerDay && (
              <Text color={isDark ? 'black' : 'white'} fontSize="xs" fontWeight="400" lineHeight={1}>
                {removeDecimals(pricePerDay)} {t('nokPerDay')}
              </Text>
            )}
            {price && (
              <Text
                color={isDark ? 'black' : 'white'}
                fontSize="xs"
                fontWeight="400"
                lineHeight={1}
                className={product.oneTimeBuy ? 'gtm-complementary-price' : ''}
              >
                {removeDecimals(price)} NOK
              </Text>
            )}
          </>
        )}
      </Box>
    </Flex>
  )
}
